const menuItemsWithChildren = document.querySelectorAll( '.desktop-header-main-menu > li.menu-item-has-children' )
const allMenuItems = document.querySelectorAll( '.desktop-header-main-menu > li' )


const init = function() {

    if ( menuItemsWithChildren ) {

        menuItemsWithChildren.forEach( item => {

            let menuTimer = null
            const button = item.querySelector( 'button' )

            // Mouse hover to display submenu
            item.addEventListener( 'mouseenter', () => {
                showDesktopSubmenu( item, menuTimer )
            } )

            // Click submenu button to display submenu
            button.addEventListener( 'click', () => {
                showDesktopSubmenu( item, menuTimer )
            } )

            // When the mouse leaves an item with children, as long
            // as the new hover target is not an ancestor, hide the submenu
            // with a slight delay for improved accessibility
            item.addEventListener( 'mouseout', ( event ) => {

                if ( item.contains( event.relatedTarget ) ) return

                menuTimer = setTimeout( () => {
                    hideDesktopSubmenu( item )
                }, 500 )

            } )

        } )

    }

    if ( allMenuItems ) {

        allMenuItems.forEach( item => {

            let menuTimer = null
            const link = item.querySelector( 'a' )

            link.addEventListener( 'focus', () => {
                console.log('Focus...')
                clearTimeout( menuTimer )
                hideAllSubmenusOnDesktop()
            } )

        } )

    }

    // On "esc" close menus
    document.addEventListener( 'keydown', ( event ) => {        
        if ( event.key === 'Escape' ) hideAllSubmenusOnDesktop()
    } )

}


const showDesktopSubmenu = function( item, timer ) {
    clearTimeout( timer )
    hideAllSubmenusOnDesktop()
    item.querySelector( 'button' ).setAttribute( 'aria-expanded', 'true' )
}


const hideAllSubmenusOnDesktop = function() {
    if ( menuItemsWithChildren ) menuItemsWithChildren.forEach( item => { hideDesktopSubmenu( item ) } )
}


const hideDesktopSubmenu = function( item ) {
    item.querySelector( 'button' ).setAttribute( 'aria-expanded', 'false' )
}


const api = {
    init: init
}


export default api;
